<template>
  <v-combobox
    v-model="shift"
    :items="shifts"
    :label="label"
    :rules="isValidShift"
    item-text="desc"
    item-value="code"
    class="dover-input"
    chips
    dense
    @change="onSelection()" >
    <template
      slot="selection"
      slot-scope="data">
      <v-chip
        :selected="data.selected"
        :disabled="data.disabled"
        :key="data.item.code"
        class="v-chip--select-multi "
        @input="data.parent.selectItem(data.item)">
        {{ data.item.desc }}
      </v-chip>
    </template>
  </v-combobox>
</template>

<script>
export default {
  props: {
    shiftNumber: {
      type: Number,
      required: true,
      default: 1
    },
    initialValue: {
      type: Object,
      required: true
    },
    isValidShift: {
      type: Array,
      required: true,
      isDate: [ v => true ]
    },
    text: {
      type: String,
      required: false,
      default: ''
    }
  },
  data: () => ({
    label: '',
    shifts: [],
    shift: { }
  }),
  mounted () {
    this.shift = this.initialValue
    if (this.text !== '') {
      this.label = this.text
    } else {
      this.label = this.$t('Shift {0}', [ this.shiftNumber ])
    }
    this.shifts.push({ code: -1, desc: this.$t('None') })

    for (let hour = 0; hour < 24; hour++) {
      for (let min = 0; min < 60; min += 15) {
        if (hour === 24 && min !== 0) break

        this.shifts.push({ code: (hour * 60) + min, desc: ('00' + hour).slice(-2) + '.' + ('00' + min).slice(-2) })
      }
    }
  },
  methods: {
    onSelection () {
      this.$emit('onShiftSelection', this.shiftNumber, this.shift)
    }
  }
}
</script>
